"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arbitraryTerminalData = exports.arbitraryMetamodule = void 0;
exports.arbitraryElementData = arbitraryElementData;
exports.arbitraryElementsMap = arbitraryElementsMap;
const tslib_1 = require("tslib");
const fast_check_1 = tslib_1.__importDefault(require("fast-check"));
const structure_1 = require("../../src/element/structure");
const part_1 = require("./part");
const property_1 = require("./property");
const vector_1 = require("./vector");
exports.arbitraryMetamodule = fast_check_1.default.record({
    attached: fast_check_1.default.constantFrom(structure_1.MetamoduleAttachmentSides.LEFT, structure_1.MetamoduleAttachmentSides.BOTTOM),
    position: vector_1.arbitraryVector3,
    visibilityToggleMap: fast_check_1.default.record({}),
});
/**
 * Generate an arbitrary terminal data instance.
 */
exports.arbitraryTerminalData = fast_check_1.default
    .tuple(fast_check_1.default.uuid(), fast_check_1.default.oneof(fast_check_1.default.constant(undefined), fast_check_1.default.string()), fast_check_1.default.oneof(fast_check_1.default.constant(undefined), fast_check_1.default.string()), fast_check_1.default.oneof(fast_check_1.default.constant(undefined), fast_check_1.default.integer().filter((x) => x >= 0)), fast_check_1.default.oneof(fast_check_1.default.constant(undefined), fast_check_1.default.string()), fast_check_1.default.oneof(fast_check_1.default.constant(undefined), vector_1.arbitraryVector2), fast_check_1.default.oneof(fast_check_1.default.constant(undefined), fast_check_1.default.lorem()))
    .map(([uid, type, name, order, label_alignment, position, userCodeData]) => {
    return { uid, type, name, order, label_alignment, position, userCodeData };
});
function arbitraryElementData(constraints = {}) {
    return fast_check_1.default.record({
        uid: (constraints.uid ? fast_check_1.default.constant(constraints.uid) : fast_check_1.default.uuid()),
        owner_uid: fast_check_1.default.uuid(),
        updated_at: fast_check_1.default.date().map((d) => d.getDate()),
        created_at: fast_check_1.default.date().map((d) => d.getDate()),
        // TODO: This doesn't actually conform to the type... this is testing "reasonable behavior"
        label: constraints.label ? fast_check_1.default.constant(constraints.label) : fast_check_1.default.hexaString({ minLength: 2 }),
        part_uid: constraints.part_uid ? fast_check_1.default.constant(constraints.part_uid) : fast_check_1.default.uuid(),
        part_version_data_cache: constraints.part_version_data_cache
            ? fast_check_1.default.constant(constraints.part_version_data_cache)
            : part_1.arbitraryPartVersionData,
        properties: constraints.properties ? fast_check_1.default.constant(constraints.properties) : property_1.arbitraryPropertiesMap,
        metamodule: exports.arbitraryMetamodule,
        part_version: constraints.part_version ? fast_check_1.default.constant(constraints.part_version) : fast_check_1.default.string(),
        diagram_position: vector_1.arbitraryVector2,
        userCodeData: fast_check_1.default.string(),
    });
}
function arbitraryElementsMap(constraints = {}) {
    const defaultMax = 10;
    const ids = fast_check_1.default.uniqueArray(fast_check_1.default.uuid(), {
        minLength: constraints.minElements ?? 1,
        maxLength: constraints.maxElements ?? defaultMax,
    });
    const elements = ids.chain((ids) => {
        return fast_check_1.default.tuple(...ids.map((id) => arbitraryElementData({ uid: id })));
    });
    return elements.map((es) => {
        const map = {};
        // eslint-disable-next-line @buildwithflux/no-array-foreach
        es.forEach((el) => (map[el.uid] = el));
        return map;
    });
}
//# sourceMappingURL=element.js.map